/* eslint-disable @typescript-eslint/no-explicit-any */
import {
	Card,
	Col,
	Image,
	Row,
	Modal,
	Typography,
	Dropdown,
	// Select
} from 'antd';
import type { MenuProps } from 'antd';
import UserProfileModal from 'components/Profile';
// import { SettingsBody } from 'components/settings';
// import { FORMDATA } from 'constants/Data';
// import SettingsLayout from 'layouts/Settings';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { adoptRunningConversation, bumpConversations, endRunningConversation, markConversationUnread } from 'redux/slice/chatBubbleSlice';
// import { getCompanyDetails } from 'redux/slice/companySlice';
import { logoutAction } from 'redux/slice/loginSlice';
import { updateCurrentTab } from 'redux/slice/transactionSlice';
import { AppDispatch } from 'redux/store';
// import { checkPermission, hasText } from 'utils/utils';
// import SideDrawerWrapper from '../SideDrawerWrapper';
import UserNameBox from '../UserNameBox';
import styles from './index.module.scss';
import './index.scss';
import { CompanySelector } from '../CompanySelector';
import { Badge, Button, Popover } from 'antd';
import {
	BellOutlined,
	InfoCircleOutlined,
	LogoutOutlined,
} from '@ant-design/icons';
import useWebSocket from '../../Global/WebSocket/useWebSocket';
import { payPeriodOptionsAction } from 'redux/action/payPeriodAction';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { getEmployeeCostAction } from 'redux/action/employeeCostAction';
import { getEmployeeCostColumnAction } from 'redux/action/employeeCostColumnSlice';
import dayjs from 'dayjs';
const { Text } = Typography;

// Website header
const Header = () => {
	// Inits
	// const { settingsMenuItems } = FORMDATA;
	const dispatch = useDispatch<AppDispatch>();
	const navigate = useNavigate();
	const location = useLocation();
	// const [drawerAnimation, setDrawerAnimation] = useState<boolean>(false);
	// const [isSideDrawerOpen, setSideDrawerOpen] = useState<boolean>(false);
	// const [filteredMenuItems, setFilteredMenuItems] = useState<any>([]);

	// const [searchParams] = useSearchParams();

	// const settingsItem = localStorage.getItem('settings') || 'Users';

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const [queryParams, setQueryParams] = useSearchParams();

	// const openDrawerFlag = searchParams.get('openDrawer');
	// const activeKey = searchParams.get('activeKey');

	// const drawerSelection = queryParams.get('drawerSelection');

	// const [settingsItem, setSettingsItem] = useState<any>(
	// 	localStorage.getItem('settings') || 'Users'
	// );
	// const [selectedSidebar, setSelectedSidebar] = useState<string>(settingsItem);
	// const [drawerInfo] = useState({
	// 	drawerTitle: 'Settings',
	// });
	const [isProfileModalOpen, setProfileModalOpen] = useState<boolean>(false);

	// const [organizationOptions, setOrganizationOptions] = useState<any>([]);
	// const [selectedOrganization, setSelectedOrganization] = useState<any>(
	// 	localStorage.getItem('companyId') || ''
	// );

	const [isLogoutLoading, setIsLogoutLoading] = useState(false);

	// const selectedCompanyPermission = useSelector(
	// 	(state: any) => state?.companies?.selectedCompanyDetails?.role?.permissions
	// );

	// /* 	const { selectedCompanyDetails } = useSelector(
	// 	(state: any) => state?.companies
	// ); */

	// const { data: listOfCompanies } = useSelector(
	// 	(state: any) => state?.companies
	// );

	const { data: userData } = useSelector((state: any) => state?.userProfile);
	const { currentTab } = useSelector((state: any) => state.transactions);
	const [profileFullName, setProfileFullName] = useState<string>('');
	const [profileImageURL, setProfileImageURL] = useState<string>('');

	// useEffect(() => {
	// 	const settingsItem = localStorage.getItem('settings');
	// 	if (settingsItem) {
	// 		setDrawerAnimation(true);
	// 		setSideDrawerOpen(true);
	// 	}
	// 	setSettingsItem(settingsItem);
	// }, [settingsItem]);

	const fetchProfile = async () => {
		try {
			const accessToken = localStorage.getItem('outsetaAccessToken');

			if (accessToken) {
				const decoded: any = jwt_decode(accessToken);
				const outsetaAccountUid = decoded['outseta:accountUid'];

				if (outsetaAccountUid) {
					localStorage.setItem('OutSetaAccountUId', outsetaAccountUid);
					// console.log('Account UID set:', outsetaAccountUid);
				} else {
					console.warn('Account UID not found in token');
				}
			}

			const response = await axios.get(
				`${process.env.REACT_APP_OUTSETA_BASE_URL}/profile`,
				{
					headers: {
						Authorization: `Bearer ${localStorage.getItem(
							'outsetaAccessToken'
						)}`,
						'Content-Type': 'application/json',
					},
				}
			);

			console.log('Profile Data:', response.data);
			if (response.data) {
				const ImageURL = response.data.ProfileImageS3Url
					? response.data.ProfileImageS3Url
					: '';
				setProfileFullName(
					response.data.FirstName + ' ' + response.data.LastName
				);
				setProfileImageURL(ImageURL);
			}
		} catch (error) {
			console.error('Error fetching profile:', error);
		}
	};

	useEffect(() => {
		// debugger;
		sessionStorage.setItem(
			'Outseta.nocode.accessToken',
			localStorage.getItem('outsetaAccessToken')!
		);
		window.Outseta.getAccessToken();
		fetchProfile();
	}, []);

	// useEffect(() => {
	// 	const companies = userData?.companies?.map((company: any) => {
	// 		return {
	// 			companyId: company.company?.id,
	// 			companyName: company.company?.tenantName,
	// 		};
	// 	});
	// 	setOrganizationOptions(companies);
	// }, [userData]);

	// For remove from the dom
	// const removeDrawerFromDom = () => {
	// 	setSideDrawerOpen(false);
	// };
	// // For open the sideDrawer with animation
	// const openDrawerHandler: any = () => {
	// 	setDrawerAnimation(true);
	// 	setSideDrawerOpen(true);
	// };

	// useEffect(() => {
	// 	if (openDrawerFlag === 'true') {
	// 		if (hasText(drawerSelection)) {
	// 			localStorage.setItem('settings', drawerSelection as string);
	// 			setSettingsItem(drawerSelection);
	// 		}
	// 		openDrawerHandler();
	// 	}
	// 	if (activeKey) {
	// 		localStorage.setItem('settings', activeKey);
	// 		setSelectedSidebar(activeKey);
	// 	}
	// }, [openDrawerFlag, drawerSelection]);

	// useEffect(() => {
	// 	if (
	// 		listOfCompanies &&
	// 		!listOfCompanies?.length &&
	// 		userData.isFirstCompanyAdmin
	// 	) {
	// 		openDrawerHandler();
	// 	}
	// }, [listOfCompanies]);

	// For perform the close animation
	// const closeDrawerByAnimation = () => {
	// 	const query: any = {};

	// 	if (queryParams.get('payPeriodId')) {
	// 		query['payPeriodId'] = queryParams.get('payPeriodId');
	// 	}

	// 	setQueryParams(query);

	// 	setDrawerAnimation(false);
	// 	filterSettingsMenuHandler();
	// 	localStorage.removeItem('settings');
	// };

	// for handle the change of the sidebar
	// const sideBarChangeHandler = (selectedValue: any) => {
	// 	localStorage.setItem('settings', selectedValue?.key);
	// 	setSelectedSidebar(selectedValue?.key);
	// };

	// Logout Handler

	const logoutHandler = async () => {
		setIsLogoutLoading(true);
		// CAP-10: Always clear storage unconditionally before redirect, regardless of
		// whether the backend logout API call succeeds or fails. Previously, storage
		// was only cleared in logoutAction.fulfilled — meaning a failed API call left
		// tokens in place, causing Outseta to treat the next /login visit as still
		// authenticated and hide the login widget.
		localStorage.clear();
		sessionStorage.clear();
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		await dispatch(logoutAction() as any).unwrap().catch(() => { /* fire and forget */ });
		window.location.href = '/login';
	};

	// My Profile Handler
	// const myProfileHandler = () => {
	// 	const profileUrl = `${
	// 		process.env.REACT_APP_OUTSETA_PROFILE_EMBED
	// 	}?access_token=${localStorage.getItem('outsetaAccessToken')}`;

	// 	const popupWidth = window.innerWidth * 0.7; // 80% of screen width
	// 	const popupHeight = window.innerHeight * 0.8; // 70% of screen height
	// 	const left = (window.innerWidth - popupWidth) / 2 + window.screenX;
	// 	const top = (window.innerHeight - popupHeight) / 2 + window.screenY;

	// 	window.open(
	// 		profileUrl,
	// 		'OutsetaProfile',
	// 		`width=${popupWidth},height=${popupHeight},top=${top},left=${left},resizable=yes,scrollbars=yes`
	// 	);

	// 	// window.open(
	// 	// 	`${
	// 	// 		process.env.REACT_APP_OUTSETA_PROFILE_EMBED
	// 	// 	}?access_token=${localStorage.getItem('outsetaAccessToken')}`,
	// 	// 	'_self'
	// 	// );
	// };

	const profileCancel = () => {
		setProfileModalOpen(false);
	};

	// const organizationChangeHandler = (e: any, data: any) => {
	// 	localStorage.setItem('companyId', e);
	// 	localStorage.setItem('companyName', data?.children);
	// 	localStorage.removeItem('payPeriod');
	// 	setQueryParams({});
	// 	// setSelectedOrganization(e);
	// 	dispatch(getCompanyDetails(e));
	// };

	// userData?.companies?.find(
	// 	(singleCompany: any) => singleCompany.companyId === selectedOrganization
	// );

	// const filterSettingsMenuHandler = () => {
	// 	const filteredPermissionsState = settingsMenuItems.map(
	// 		(singleMenuItem: any) => {
	// 			return checkPermission(selectedCompanyPermission, {
	// 				permissionName: singleMenuItem?.key,
	// 				permission: ['view'],
	// 			});
	// 		}
	// 	);

	// 	if (!listOfCompanies?.length) {
	// 		filteredPermissionsState[2] = true;
	// 	}

	// 	const filteredMenuItems = settingsMenuItems.filter(
	// 		(_, i) => filteredPermissionsState[i]
	// 	);

	// 	setFilteredMenuItems(filteredMenuItems);

	// 	// if (!selectedSidebar) {
	// 	setSelectedSidebar(filteredMenuItems[0]?.key);
	// 	// }
	// };

	// const isAnyUserPermission = checkPermission(selectedCompanyPermission, {
	// 	permissionName: 'Users',
	// 	permission: ['add', 'all', 'edit', 'view', 'delete'],
	// });
	// const isAnyRolePermission = checkPermission(selectedCompanyPermission, {
	// 	permissionName: 'Roles',
	// 	permission: ['add', 'all', 'edit', 'view', 'delete'],
	// });

	// const isAnyIntegrationPermission = checkPermission(
	// 	selectedCompanyPermission,
	// 	{
	// 		permissionName: 'Integrations',
	// 		permission: ['add', 'all', 'edit', 'view', 'delete'],
	// 	}
	// );

	// const isAnySubscriptionPermission = checkPermission(
	// 	selectedCompanyPermission,
	// 	{
	// 		permissionName: 'Subscriptions',
	// 		permission: ['add', 'all', 'edit', 'view', 'delete'],
	// 	}
	// );

	// const isAnyConfigurationPermission = checkPermission(
	// 	selectedCompanyPermission,
	// 	{
	// 		permissionName: 'Configurations',
	// 		permission: ['add', 'all', 'edit', 'view', 'delete'],
	// 	}
	// );

	// const isAnySyncLogsPermission = checkPermission(selectedCompanyPermission, {
	// 	permissionName: 'Sync Logs',
	// 	permission: ['add', 'all', 'edit', 'view', 'delete'],
	// });

	// const isAnyCustomRulePermission = checkPermission(selectedCompanyPermission, {
	// 	permissionName: 'Custom Rules',
	// 	permission: ['add', 'all', 'edit', 'view', 'delete'],
	// });

	// useEffect(() => {
	// 	filterSettingsMenuHandler();
	// }, [selectedCompanyPermission, listOfCompanies]);

	// console.log('userData?.id', userData?.id);
	// if (userData?.id) {
	// 	console.error('Web Socket Failed Due To Undefined parameter');
	// }

	const { message } = useWebSocket(
		`${process.env.REACT_APP_API_ENDPOINT}`,
		userData?.id
	);

	// Flag AI-chat replies that arrive for a thread the user isn't looking at.
	// `message` is an append-only array, so a ref tracks how far we've processed.
	const activeConversationId = useSelector(
		(state: any) => state.chatBubble?.activeConversationId ?? null
	);
	const processedChatMsgRef = useRef(0);
	useEffect(() => {
		if (!Array.isArray(message)) return;
		for (let i = processedChatMsgRef.current; i < message.length; i += 1) {
			const msg = message[i];
			// Fired the moment the question is saved (before the reply): show the
			// real saved thread in the sidebar now. Attaching its id to the running
			// chat turns the temporary "new chat" row into the real thread (with a
			// spinner) rather than leaving a placeholder until the reply lands.
			if (msg?.type === 'ai_chat_user_saved' && msg.conversationId) {
				dispatch(adoptRunningConversation(msg.conversationId));
				dispatch(bumpConversations());
			}
			if (msg?.type === 'ai_chat_response' && msg.conversationId) {
				// The reply is done, so this thread is no longer "working" — clear its
				// spinner. The initiating view clears its own in the send's `finally`,
				// but a running state set via the WS `adopt` path (a reply finished in
				// another tab/session, or after this view navigated away, or a late
				// ai_chat_user_saved that re-set it after that finally) has no other
				// teardown — without this it would spin forever.
				dispatch(endRunningConversation(msg.conversationId));
				// If they're on /chat looking at this very thread, the live reply
				// already showed — don't flag it. Otherwise mark it unread.
				const viewingLive =
					window.location.pathname === '/chat' &&
					activeConversationId === msg.conversationId;
				if (!viewingLive) {
					dispatch(markConversationUnread(msg.conversationId));
				}
				// Refresh the sidebar so a brand-new thread (created while away)
				// appears, and titles/order update.
				dispatch(bumpConversations());
			}
		}
		processedChatMsgRef.current = message.length;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [message]);

	const [notifications, setNotifications] = useState<any[]>([]);
	const [removedNotifications, setRemovedNotifications] = useState<string[]>([]);

	const [visible, setVisible] = useState(false);

	// Helper function to generate unique key for notifications
	const getNotificationKey = (notification: any) => {
		if (notification.type === 'SyncTransactions' || notification.type === 'UpdateTransactions') {
			return `${notification.type}-${notification.dateRange}-${notification.companyId}-${notification.createdAt}`;
		}
		if (notification.type === 'attachmentDownload') {
			return `${notification.type}-${notification.companyName}-${notification.createdAt}`;
		}
	};

	const [showConfigAlert, setShowConfigAlert] = useState(false);
	const [payPeriodIdToRedirect, setPayPeriodIdToRedirect] = useState(null);

	const handleCancel = () => {
		setShowConfigAlert(false);
	};

	const handleRedirect = () => {
		setShowConfigAlert(false);
		if (payPeriodIdToRedirect) {
			handleConfigOpen(payPeriodIdToRedirect);
		}
	};

	// Handle popover visibility
	const handleVisibleChange = (visible: boolean) => {
		setVisible(visible);
	};

	useEffect(() => {
		if (message.length > 0) {
			// Filter new messages not already in notifications and not permanently removed
			const newMessages = message.filter((msg: any) => {
				// Chat WebSocket events drive the sidebar (unread dots, saved thread),
				// never the notification bell — keep them out of the bell entirely.
				if (msg.type === 'ai_chat_response' || msg.type === 'ai_chat_user_saved') {
					return false;
				}
				// For sync or update notification types, filter by date range and createdAt instead of payPeriodId
				if (msg.type === 'SyncTransactions' || msg.type === 'UpdateTransactions') {
					const msgKey = getNotificationKey(msg);

					// Check if notification was permanently removed
					if (msgKey && removedNotifications.includes(msgKey)) {
						return false;
					}
					return !notifications.some((notification: any) =>
						notification.type === msg.type &&
						notification.dateRange === msg.dateRange &&
						notification.companyId === msg.companyId &&
						notification.createdAt === msg.createdAt
					);
				}
				// For attachmentDownload notification type, filter by companyName, createdAt, and users
				if (msg.type === 'attachmentDownload') {
					const msgKey = getNotificationKey(msg);

					// Check if notification was permanently removed
					if (msgKey && removedNotifications.includes(msgKey)) {
						return false;
					}
					return !notifications.some((notification: any) =>
						notification.type === msg.type &&
						notification.companyName === msg.companyName &&
						notification.createdAt === msg.createdAt
					);
				}
				// For other notification types, continue using payPeriodId
				return !notifications.some(
					(notification: any) => notification.payPeriodId === msg.payPeriodId
				);
			});

			// If there are new messages, sort them and add to notifications
			if (newMessages.length > 0) {
				const sortedMessages = newMessages.sort(
					(a: any, b: any) =>
						new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
				);

				setNotifications((prevNotifications) => [
					...prevNotifications,
					...sortedMessages,
				]);
			}

			// Dispatch download notifications as CustomEvent for DownloadAttachmentModal
			// This includes both attachmentDownload and attachmentDownloadProgress types
			const downloadNotifications = message.filter(
				(msg: any) =>
					msg.type === 'attachmentDownload' ||
					msg.type === 'attachmentDownloadProgress' ||
					(msg.requestId &&
						(msg.status === 'finished' ||
							msg.status === 'completed' ||
							msg.status === 'failed' ||
							msg.status === 1 ||
							msg.status === 0 ||
							msg.status === '1' ||
							msg.status === '0'))
			);

			if (downloadNotifications.length > 0) {
				console.log('Header: Dispatching download notifications', downloadNotifications);
			}

			downloadNotifications.forEach((notification: any) => {
				window.dispatchEvent(
					new CustomEvent('download-notification', {
						detail: notification,
					})
				);
			});
		}
	}, [message]); // Add companyId and message as dependencies

	const handleConfigOpen = async (payPeriodId: string) => {
		localStorage.setItem('settings', 'Configurations');

		const _query: any = {
			openDrawer: 'true',
		};

		if (queryParams.get('payPeriodId')) {
			_query.payPeriodId = payPeriodId;
		}

		if (queryParams.get('isNewPayPeriod') === 'true') {
			_query.isNewPayPeriod = 'true';
		}
		await dispatch(
			getEmployeeCostColumnAction({
				payPeriodId,
			})
		)
			.unwrap()
			.then(() => {
				//
			});

		await dispatch(
			getEmployeeCostAction({
				payPeriodId,
			})
		);
		setQueryParams(_query);
	};

	const handleNotificationClick = async (notification: any) => {
		try {
			// Generate unique key for this notification
			const notificationKey = getNotificationKey(notification);

			// Permanently mark this notification as removed
			if (notificationKey) {
				setRemovedNotifications(prev => [...prev, notificationKey]);
			}

			if (notification?.type === 'attachmentDownload') {
				// Navigate to expense allocation page and open history modal
				navigate(
					'/expense-allocations?openHistoryModal=true&historyFilter=all'
				);
				// Remove the notification from the list
				setNotifications((prevNotifications) =>
					prevNotifications.filter(
						(PrevNotification) => {
							const prevKey = getNotificationKey(PrevNotification);
							const currentKey = getNotificationKey(notification);
							return prevKey !== currentKey;
						}
					)
				);
				return;
			}

			// Handle UpdateTransactions and SyncTransactions notifications
			if (notification?.type === 'UpdateTransactions' || notification?.type === 'SyncTransactions') {

				setNotifications((prevNotifications) =>
					prevNotifications.filter(
						(PrevNotification) =>
							!(PrevNotification.type === notification.type &&
								PrevNotification.dateRange === notification.dateRange &&
								PrevNotification.companyId === notification.companyId &&
								PrevNotification.createdAt === notification.createdAt)
					)
				);

				const currentCompanyId = localStorage.getItem('companyId');
				const currentPath = location.pathname;
				const isOnExpenseAllocationsPage = currentPath === '/expense-allocations';

				// Check if notification companyId matches current selected company
				if (notification?.companyId && notification.companyId === currentCompanyId) {
					// Parse date range from notification
					let parsedDateRange = null;
					if (notification?.dateRange) {
						try {
							const [startDate, endDate] = notification.dateRange.split(' to ');
							if (startDate && endDate) {
								parsedDateRange = [dayjs(startDate), dayjs(endDate)];
							}
						} catch (error) {
							console.error('Error parsing date range from notification:', error);
						}
					}

					if (isOnExpenseAllocationsPage) {
						// User is on expense-allocations page
						// Switch to tab 1 (Transactions tab) if not already there
						if (currentTab !== '1') {
							dispatch(updateCurrentTab('1'));
						}

						// Set date range and trigger data fetch
						if (parsedDateRange) {
							// Dispatch custom event to update date range and fetch data
							// The ExpenseAllocationPage component should listen for this event
							// and update its date range state and trigger appropriate fetch functions
							const customEvent = new CustomEvent('notificationDateRangeUpdate', {
								detail: {
									dateRange: parsedDateRange,
									notificationType: notification.type
								}
							});
							window.dispatchEvent(customEvent);
						}
					} else {
						// Different page - navigate to expense-allocations with date range
						if (parsedDateRange) {
							const dateRangeParams = new URLSearchParams({
								tab: '1',
								fromDate: parsedDateRange[0].format('YYYY-MM-DD'),
								toDate: parsedDateRange[1].format('YYYY-MM-DD')
							});
							navigate(`/expense-allocations?${dateRangeParams.toString()}`);
						} else {
							navigate('/expense-allocations?tab=1');
						}
					}
				} else {
					// Different company - notification already cleared above
					console.log('Notification company does not match current company, notification removed');
				}

				// No page reload needed - let the custom events handle the updates
				return;
			}

			// Assuming notification has the necessary details for payPeriodId or related params
			await dispatch(payPeriodOptionsAction());

			const excludedTypes = [
				'CompanyDeletion',
				'SyncTransactions',
				'UpdateTransactions',
			];
			if (!excludedTypes.includes(notification?.type)) {
				const query: any = {
					payPeriodId: notification?.payPeriodId, // Use appropriate field from notification or response
				};
				setQueryParams(query); // Update query parameters based on the clicked notification
				setNotifications((prevNotifications) =>
					prevNotifications.filter(
						(PrevNotification) =>
							PrevNotification.payPeriodId !== notification.payPeriodId
					)
				);
			} else {
				//want to remove payperiod from query params
				setQueryParams({});
				// localStorage.removeItem('payPeriod');
			}
			if (notification.type == 'ImportEmployeeCost') {
				localStorage.setItem(
					'importStatus',
					JSON.stringify(notification?.createdNewFieldFlag)
				);
				if (notification?.createdNewFieldFlag) {
					setPayPeriodIdToRedirect(notification.payPeriodId);
					setShowConfigAlert(true);
				} else {
					window.location.reload();
				}
			} else {
				window.location.reload();
			}

			console.log('Notification clicked:', notification);
		} catch (error) {
			console.error('Error handling notification click:', error);
		}
	};

	const clearAllNotifications = () => {
		// Permanently mark sync, update and attachmentDownload notifications as removed using their keys
		const syncUpdateKeys = notifications
			.filter(notification =>
				notification.type === 'SyncTransactions' || notification.type === 'UpdateTransactions' || notification.type === 'attachmentDownload'
			)
			.map(notification => getNotificationKey(notification))
			.filter((key): key is string => key !== undefined);

		setRemovedNotifications(prev => [...prev, ...syncUpdateKeys]);

		// Clear current notifications
		setNotifications([]);
		console.log('All notifications cleared.');
	};

	// Popover content
	const popoverContent = (
		<div style={{ width: 300 }}>
			{notifications?.length > 0 ? (
				<>
					<div
						className="notification-scroll-container"
						style={{
							maxHeight: '400px',
							overflowY: 'auto',
							marginBottom: '10px',
						}}
					>
						{notifications.map((notification: any, index: any) => (
							<Card
								key={index}
								onClick={() => handleNotificationClick(notification)}
								hoverable
								style={{
									marginBottom: 10,
									cursor: 'pointer',
									padding: '2px 8px 0px 8px',
								}}
							>
								<div style={{ display: 'flex', flexDirection: 'column' }}>
									<span
										style={{
											color: notification.status === 0 ? 'red' : 'inherit',
											fontWeight: 'bold',
											fontSize: '12px',
										}}
									>
										{notification.title}
									</span>
									<span
										style={{
											fontSize: '12px',
											marginBottom: '8px',
										}}
									>
										{notification.description}
									</span>
								</div>
								<div
									style={{
										display: 'flex',
										justifyContent: 'flex-end', // Push content to the right
									}}
								>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column', // Align elements vertically
											alignItems: 'flex-end', // Align text to the right
											fontSize: '12px',
										}}
									>
										<span
											style={{
												color: '#485949',
												fontSize: '12px',
											}}
										>
											{notification.companyName}
										</span>
										<span
											style={{
												color: '#485949',
												fontSize: '12px',
											}}
										>
											{notification.createdAt}
										</span>
									</div>
								</div>
							</Card>
						))}
					</div>
					<Button
						type="link"
						style={{ width: '100%', textAlign: 'center', fontSize: '12px' }}
						onClick={clearAllNotifications}
					>
						Clear All
					</Button>
				</>
			) : (
				<p style={{ textAlign: 'center', margin: 0, fontSize: '12px' }}>
					No new notifications
				</p>
			)}
		</div>
	);



	// JSX

	const profileMenuItems: MenuProps['items'] = [
		{
			key: 'name',
			label: profileFullName,
			disabled: true,
			style: { fontWeight: 'bold', fontSize: '12px' },
		},
		{
			key: 'profile',
			label: (
				<a
					data-o-profile="1"
					data-mode="popup"
					data-tab="profile"
					style={{
						color: 'black',
						fontSize: '12px',
						fontWeight: 300,
					}}
				>
					My Profile
				</a>
			),
		},
	];

	return (
		<>
			<header className={styles['header']}>
				<Row
					className={styles['header__wrapper']}
					align={'middle'}
					justify={'space-between'}
				>
					<Col className={styles['header__details-left']}>
						<div className={styles['header__details-left--logo']}>
							<Image
								src="/assets/images/cap-logo-2.png"
								preview={false}
								alt="group"
							/>
						</div>
					</Col>
					<Col className={styles['header__details-right']}>
						<CompanySelector />

						{/* {(isAnyConfigurationPermission ||
							(listOfCompanies?.length === 0 && userData.isFirstCompanyAdmin) ||
							isAnyIntegrationPermission ||
							isAnyRolePermission ||
							isAnySubscriptionPermission ||
							isAnyCustomRulePermission ||
							isAnyUserPermission) && (
							<div
								className={styles['header__details-right--settings']}
								onClick={() => {
									openDrawerHandler();
									if (isAnyUserPermission) {
										localStorage.setItem('settings', 'Users');
									} else if (isAnyRolePermission) {
										localStorage.setItem('settings', 'Roles');
									} else if (isAnyIntegrationPermission) {
										localStorage.setItem('settings', 'Integrations');
									} else if (isAnySubscriptionPermission) {
										localStorage.setItem('settings', 'Subscription');
									} else if (isAnyConfigurationPermission) {
										localStorage.setItem('settings', 'Configurations');
									} else if (isAnySyncLogsPermission) {
										localStorage.setItem('settings', 'Sync Logs');
									} else if (isAnyCustomRulePermission) {
										localStorage.setItem('settings', 'CustomRules');
									}
								}}
							>
								<Image
									src="/assets/images/settings.png"
									preview={false}
									alt="group"
								/>
							</div>
						)} */}

						<div
							className={styles['header__details-right--settings']}
							style={
								notifications.length > 0 ? { marginRight: '1rem' } : undefined
							}
						>
							<Popover
								content={popoverContent}
								title={() => (
									<p
										style={{
											fontSize: '16px',
										}}
									>
										Notifications
									</p>
								)} // title="Notifications"
								trigger="click"
								open={visible}
								onOpenChange={handleVisibleChange}
							>
								<Badge
									count={notifications.length}
									offset={[10, 0]}
								>
									<BellOutlined
										style={{ fontSize: '24px', cursor: 'pointer' }}
									/>
								</Badge>
							</Popover>
						</div>

						<Dropdown
							menu={{ items: profileMenuItems }}
							trigger={['click']}
							placement="bottom"
						>
							<div
								className={styles['header__details-right--user']}
								style={{ cursor: 'pointer' }}
							>
								<div className={styles['header__details-right--user-logo']}>
									<UserNameBox
									name={profileFullName}
									imageUrl={`${process.env.REACT_APP_API_ENDPOINT}/proxy-image?url=${profileImageURL}`}
									profileImageURL={profileImageURL}
									/>
								</div>
							</div>
						</Dropdown>
						<div className={styles['header__details-right--user-logout']}>
							<div
								className={isLogoutLoading ? 'pointer-event-none' : ''}
								onClick={logoutHandler}
							>
								{/* <Image
									src="/assets/images/logout3.png"
									preview={false}
									alt="group"
								> */}
								<LogoutOutlined style={{ fontSize: '23px' }} />
							</div>
						</div>
					</Col>
				</Row>
			</header>

			{/* {isSideDrawerOpen && (
				<SideDrawerWrapper
					isOpen={drawerAnimation}
					removeDrawerFromDom={removeDrawerFromDom}
					closeDrawerByAnimation={closeDrawerByAnimation}
					headerTitle={drawerInfo.drawerTitle}
					position="bottom"
					width="full"
				>
					<SettingsLayout
						filteredMenuItems={filteredMenuItems}
						onSideBarChange={sideBarChangeHandler}
						selectedSidebar={selectedSidebar}
					>
						<SettingsBody
							selectedSidebar={selectedSidebar}
							setSelectedSidebar={setSelectedSidebar}
							closeDrawerByAnimation={closeDrawerByAnimation}
							openDrawerHandler={openDrawerHandler}
						/>
					</SettingsLayout>
				</SideDrawerWrapper>
			)} */}

			{isProfileModalOpen && (
				<UserProfileModal
					isProfileModalOpen={isProfileModalOpen}
					handleCancel={profileCancel}
				/>
			)}

			{showConfigAlert && (
				<Modal
					open={showConfigAlert}
					onOk={handleRedirect}
					onCancel={handleCancel}
					okText="Go to Configuration"
					cancelText="Cancel"
					centered
					title={
						<div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
							<InfoCircleOutlined style={{ color: '#1890ff', fontSize: 16 }} />
							<Text strong>Configuration Required</Text>
						</div>
					}
					okButtonProps={{
						style: {
							backgroundColor: '#344735',
							borderColor: '#344735',
							color: '#fff',
							borderRadius: '12px',
							fontSize: '12px',
						},
					}}
					cancelButtonProps={{
						style: {
							backgroundColor: '#fff',
							borderColor: '#1e2b1f',
							color: '#151a15',
							borderRadius: '12px',
							fontSize: '12px',
						},
					}}
				>
					<Text style={{ fontSize: '12px' }}>
						A new field has been created that requires configuration. Would you
						like to go to the configuration page now?
					</Text>
				</Modal>
			)}
		</>
	);
};

export default Header;
